import { render, staticRenderFns } from "./MobileResource.vue?vue&type=template&id=092b123c&scoped=true"
import script from "./MobileResource.vue?vue&type=script&lang=js"
export * from "./MobileResource.vue?vue&type=script&lang=js"
import style0 from "./MobileResource.vue?vue&type=style&index=0&id=092b123c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092b123c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('092b123c')) {
      api.createRecord('092b123c', component.options)
    } else {
      api.reload('092b123c', component.options)
    }
    module.hot.accept("./MobileResource.vue?vue&type=template&id=092b123c&scoped=true", function () {
      api.rerender('092b123c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/homePage/mobile/MobileResource.vue"
export default component.exports